export const PROBE_ERROR_MESSAGES = {
  ADD_LIC_FAILED: 'ADD_LIC_FAILED',
  ACTION_COMPLETED_SEND_EMAIL_FAILED: 'ACTION_COMPLETED_SEND_EMAIL_FAILED',
  MISSING_PARAMETER_EMPLOYEE_IDENTIFIER: 'MISSING_PARAMETER_EMPLOYEE_IDENTIFIER',
  MISSING_PARAMETER_EMPLOYEE_EMAIL: 'MISSING_PARAMETER_EMPLOYEE_EMAIL',
  MISSING_PARAMETER_EMPLOYEE_LICENSE: 'MISSING_PARAMETER_EMPLOYEE_LICENSE',
  MISSING_PARAMETER_EMPLOYEE_GROUP: 'MISSING_PARAMETER_EMPLOYEE_GROUP',
  MISSING_PARAMETER_PASSWORD_INFO: 'MISSING_PARAMETER_PASSWORD_INFO',
  INVALID_AUTHENTICATION_TOKEN: 'GENERAL.INVALID_AUTHENTICATION_TOKEN',
  BLOCK_USER_FAILED: 'BLOCK_USER_FAILED',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  GWS_PRIMARY_EMAIL_NOT_SAVED: 'GWS_PRIMARY_EMAIL_NOT_SAVED',
}

export const getErrorMessageFromProbeTask = ({ error, intl }) => {
  let message = error.rawMessage
  const messageId = PROBE_ERROR_MESSAGES[error?.StatusMessage]

  if (error?.isErrorCode && messageId) {
    message = intl.formatMessage({ id: messageId })
  } else if (error?.StatusMessage === 'Forbidden') {
    message = `${intl.formatMessage({ id: 'GENERAL.FORBIDDEN' })}. ${error.rawMessage}`
  }

  return message
}
